import { Buffer } from "buffer";
import { VersionedTransaction } from "@solana/web3.js";
import nacl from "tweetnacl";
import { assertWalletMessage, WalletPolicyError } from "./walletMessage.js";
export { assertWalletMessage, WalletPolicyError } from "./walletMessage.js";
export { LIGHTHOUSE_PROGRAM, ASSERTION_PACKET_RESERVE, APPROVAL_COMPUTE_UNITS, validLighthouseAssertion } from "./lighthouse.js";
export const WALLET_POLICY_VERSION = "LIGHTHOUSE_V1";
export function verifyTransactionSignatures(tx, ownerOnly = false) {
    const count = ownerOnly ? 1 : tx.message.header.numRequiredSignatures;
    const bytes = tx.message.serialize();
    for (let i = 0; i < count; i++)
        if (!tx.signatures[i] || !nacl.sign.detached.verify(bytes, tx.signatures[i], tx.message.staticAccountKeys[i].toBytes()))
            throw new WalletPolicyError("signature");
}
export function assertTransactionPolicy(prepared, signed, ownerOnly = false, tables = []) {
    const before = VersionedTransaction.deserialize(Buffer.from(prepared, "base64"));
    const after = VersionedTransaction.deserialize(Buffer.from(signed, "base64"));
    assertWalletMessage(before.message, after.message, tables);
    verifyTransactionSignatures(after, ownerOnly);
    if (after.serialize().length > 1232)
        throw new WalletPolicyError("packet_limit");
    return after;
}
export function ownerApprovalBytes(prepared) {
    const tx = VersionedTransaction.deserialize(Buffer.from(prepared, "base64"));
    if (tx.signatures[0]?.some(b => b !== 0))
        throw new WalletPolicyError("already_signed");
    return Buffer.from(new VersionedTransaction(tx.message).serialize()).toString("base64");
}
export { buildResourceClaimChunk, resourceClaimChunkInstructions, validateResourceClaimChunkManifest, validateSignedResourceClaimChunk, matchesResourceClaimChunk, MaterialClaimError, RESOURCE_CLAIM_CHUNK_MAX_ITEMS, RESOURCE_CLAIM_CHUNK_COMPUTE_UNITS, MATERIAL_CLAIM_PRIORITY_MICROLAMPORTS } from "./materialClaim.js";
export * from "./materialCollection.js";
export * from "./crewContribution.js";
